import { Env, getEnv } from './env';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';
type LogData = {
  level: LogLevel;
  message: string;
  data?: unknown;
};
const env = getEnv();

const hiddenLevels: Record<Env, LogLevel[]> = {
  production: ['debug', 'info', 'warn'],
  qa: ['debug'],
  development: [],
  sandbox: [],
};

function shouldLog(level: LogLevel) {
  return !hiddenLevels[env]?.includes(level);
}

function baseLog(logData: LogData) {
  if (!shouldLog(logData.level)) return;
  const { level, message, data } = logData;
  const outputData = () => {
    if (data instanceof Error) {
      return {
        name: data.name,
        message: data.message,
        stack: data.stack,
      };
    }
    return data;
  };
  const logEntry = {
    level,
    message,
    data: outputData(),
    env,
    time: new Date().toISOString(),
  };
  switch (level) {
    case 'debug':
      console.debug(logEntry);
      break;
    case 'info':
      console.info(logEntry);
      break;
    case 'warn':
      console.warn(logEntry);
      break;
    case 'error':
      console.error(logEntry);
      break;
    default:
      console.log(logEntry);
  }
}

export const log = {
  debug: (data: Omit<LogData, 'level'>) => baseLog({ level: 'debug', ...data }),
  info: (data: Omit<LogData, 'level'>) => baseLog({ level: 'info', ...data }),
  warn: (data: Omit<LogData, 'level'>) => baseLog({ level: 'warn', ...data }),
  error: (data: Omit<LogData, 'level'>) => baseLog({ level: 'error', ...data }),
};
